import { getPatternStyles, patternFns, __spreadValues, __objRest } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const scrollableConfig = {
transform(props) {
  const _a = props, { direction, hideScrollbar } = _a, rest = __objRest(_a, ["direction", "hideScrollbar"]);
  return __spreadValues({
    overflow: "auto",
    height: direction === "horizontal" ? "100%" : "auto",
    width: direction === "vertical" ? "100%" : "auto",
    scrollbarWidth: hideScrollbar ? "none" : "auto",
    WebkitOverflowScrolling: "touch",
    colorScheme: "light",
    "&::-webkit-scrollbar": {
      display: hideScrollbar ? "none" : "auto"
    },
    _dark: {
      colorScheme: "dark"
    }
  }, rest);
}}

export const getScrollableStyle = (styles = {}) => {
  const _styles = getPatternStyles(scrollableConfig, styles)
  return scrollableConfig.transform(_styles, patternFns)
}

export const scrollable = (styles) => css(getScrollableStyle(styles))
scrollable.raw = getScrollableStyle